const grid1 = "go16ogp";
const grid2 = "g1wqlp8t";
const grid3 = "g16douhw";
const spanFull = "sm3gm9x";
export const getWrapperClass = (count: number) => {
  switch (count) {
    case 1:
      return grid1;
    case 2:
      return grid2;
    case 3:
      return grid3;
    default:
      return grid1;
  }
};
export const getWrapperFieldClass = (count: number, index: number) => {
  if (count === 3 && index === 0) return spanFull;
  return '';
};

require("./fieldClassnames.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./fieldClassnames.ts");